import { render, staticRenderFns } from "./comSolt.vue?vue&type=template&id=45c87f12&scoped=true&"
import script from "./comSolt.vue?vue&type=script&lang=js&"
export * from "./comSolt.vue?vue&type=script&lang=js&"
import style0 from "./comSolt.vue?vue&type=style&index=0&id=45c87f12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c87f12",
  null
  
)

export default component.exports